import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=5d234444&scoped=true&"
import script from "./Textarea.vue?vue&type=script&lang=js&"
export * from "./Textarea.vue?vue&type=script&lang=js&"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=5d234444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d234444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d234444')) {
      api.createRecord('5d234444', component.options)
    } else {
      api.reload('5d234444', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=5d234444&scoped=true&", function () {
      api.rerender('5d234444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/ui/forms/Textarea.vue"
export default component.exports